"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export function LanguageToggleLink({ className }: { className?: string }) {
  const pathname = usePathname();
  const isChinesePage = pathname?.startsWith("/zh");

  return (
    <Link href={isChinesePage ? "/" : "/zh"} className={className}>
      {isChinesePage ? "View in English" : "中文"}
    </Link>
  );
}
